<template>
  <div id="app">
    <CompanyHero :hero="heroImage"></CompanyHero>
    <div class="container">
      <div class="main">
        <h1>{{ companyName }}</h1>
        <div class="callout warning" v-if="isMaintenance">
          Wartungsarbeiten am Donnerstag 28.12.23 und Freitag 29.12.23. In diese
          Zeit steht ihnen die Buchungsfunktion nur eingeschränkt zur Verfügung.
          In der Nacht zwischen 20 und 4 Uhr ist keine Buchung möglich.
        </div>
        <router-view
          :settings="settings"
          v-if="dataFetched && !isMaintenance"
        ></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CompanyHero from "./components/CompanyHero.vue";

export default {
  name: "App",
  components: { CompanyHero },
  data() {
    return {
      settings: null,
      dataFetched: false
    };
  },
  computed: {
    companyName() {
      return this.settings === null ? "" : this.settings.company;
    },
    isMaintenance() {
      const now = new Date();
      const dateFrom = new Date("2025-03-28 20:00");
      const dateTo = new Date("2025-03-30 23:00");

      if (now >= dateFrom && now <= dateTo) {
        return true;
      }

      return false;
    },
    heroImage() {
      return this.settings?.heroImage === undefined
        ? "default"
        : this.settings.heroImage;
    }
  },
  created() {
    const vue = this;
    localStorage.setItem("locationAlias", this.$route.params.alias);
    const alias = localStorage.getItem("locationAlias");

    if (
      alias !== "undefined" &&
      this.settings !== null &&
      this.settings.id > 0 &&
      this.settings.alias === alias
    ) {
      this.axios.defaults.headers["X-LOCATION"] = this.settings.id;
      this.dataFetched = true;
      if (this.$route.name === "start") {
        this.$router.push({
          name: "courseList",
          props: { alias: alias }
        });
      }
    } else if (alias !== "undefined") {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/public/locations/" +
            alias +
            "/settings"
        )
        .then(response => {
          vue.settings = response.data;
          localStorage.setItem("settings", JSON.stringify(response.data));
          vue.axios.defaults.headers["X-LOCATION"] = response.data.id;
          vue.dataFetched = true;
          if (this.$route.name === "start") {
            vue.$router.push({
              name: "courseList",
              props: { alias: response.data.alias }
            });
          }
        });
    }
  }
};
</script>
